export default __webpack_public_path__ + "static/media/clientslist-icon.0dcd5f8f.svg";